var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hornor-buy-guide"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"enquiries"},[_c('button',{on:{"click":_vm.getUserAuth}},[_vm._v("马上查询我的礼包价值")])]),_c('div',{staticClass:"desc"},[_vm._v("还有机会成为内蒙古移动黑卡plus会员，尽享会员十大权益，抢95折超市现金券、8折大牌白酒、2折品牌耳机音箱、3折热门视频会员。")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }